import React from 'react';
import { PartnersItem } from './PartnersItem/PartnersItem';
import aruba from '../../images/partners/Aruba_Networks_logo.svg';
import cisco from '../../images/partners/Cisco_logo (1).svg';
import dell from '../../images/partners/Dell_logo.svg';
import hpe from '../../images/partners/Hewlett_Packard_Enterprise_logo.svg';
import microfocus from '../../images/partners/Micro_Focus_logo.svg';
import microsoft from '../../images/partners/Microsoft_logo_(2012) (1).svg';
import vmware from '../../images/partners/Vmware.svg';
import geetoo from '../../images/partners/geetoo-logo.png';
import './partners.scss';

export const Partners = () => {
  return (
    <div className="partners_section" id="partners">
      <h2>Naši partneři</h2>
      <div className="partners">
        <PartnersItem partnerLogo={cisco} partnerAlt="Cisco logo" />
        <PartnersItem partnerLogo={microsoft} partnerAlt="Microsoft logo" />
        <PartnersItem partnerLogo={dell} partnerAlt="Dell logo" />
        <PartnersItem
          partnerLogo={hpe}
          partnerAlt="Hewlett Packard Enterprise logo"
        />
        <PartnersItem partnerLogo={aruba} partnerAlt="Aruba Networks logo" />
        <PartnersItem partnerLogo={microfocus} partnerAlt="Micro Focus logo" />
        <PartnersItem partnerLogo={vmware} partnerAlt="Vmware logo" />
        <PartnersItem partnerLogo={geetoo} partnerAlt="Geetoo logo" />
      </div>
    </div>
  );
};
